"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDictionaryEvidence = exports.createDictionaryRowStyle = exports.dictionarySubtitle = exports.dictionaryActionbarFactory = exports.FieldCode = exports.FieldValidTo = exports.FieldValidFrom = exports.FieldActive = exports.FieldName = exports.FieldOrder = exports.DictionaryFields = exports.useDictionaryColumns = void 0;
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const dictionary_columns_1 = require("./dictionary-columns");
Object.defineProperty(exports, "useDictionaryColumns", { enumerable: true, get: function () { return dictionary_columns_1.useDictionaryColumns; } });
const dictionary_fields_1 = require("./dictionary-fields");
Object.defineProperty(exports, "DictionaryFields", { enumerable: true, get: function () { return dictionary_fields_1.DictionaryFields; } });
Object.defineProperty(exports, "FieldOrder", { enumerable: true, get: function () { return dictionary_fields_1.FieldOrder; } });
Object.defineProperty(exports, "FieldName", { enumerable: true, get: function () { return dictionary_fields_1.FieldName; } });
Object.defineProperty(exports, "FieldActive", { enumerable: true, get: function () { return dictionary_fields_1.FieldActive; } });
Object.defineProperty(exports, "FieldValidFrom", { enumerable: true, get: function () { return dictionary_fields_1.FieldValidFrom; } });
Object.defineProperty(exports, "FieldValidTo", { enumerable: true, get: function () { return dictionary_fields_1.FieldValidTo; } });
Object.defineProperty(exports, "FieldCode", { enumerable: true, get: function () { return dictionary_fields_1.FieldCode; } });
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const dictionary_utils_1 = require("./dictionary-utils");
Object.defineProperty(exports, "dictionaryActionbarFactory", { enumerable: true, get: function () { return dictionary_utils_1.dictionaryActionbarFactory; } });
Object.defineProperty(exports, "dictionarySubtitle", { enumerable: true, get: function () { return dictionary_utils_1.dictionarySubtitle; } });
Object.defineProperty(exports, "createDictionaryRowStyle", { enumerable: true, get: function () { return dictionary_utils_1.createDictionaryRowStyle; } });
const dictionary_schema_1 = require("./dictionary-schema");
const dictionary_toolbar_1 = require("../../evidence/dictionary-evidence/dictionary-toolbar");
function useDictionaryEvidence(options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const { dictionaryColumns } = dictionary_columns_1.useDictionaryColumns();
    const columns = (_b = (_a = options.tableProps) === null || _a === void 0 ? void 0 : _a.columns) !== null && _b !== void 0 ? _b : dictionaryColumns;
    const createRowStyle = (_d = (_c = options.tableProps) === null || _c === void 0 ? void 0 : _c.createRowStyle) !== null && _d !== void 0 ? _d : dictionary_utils_1.createDictionaryRowStyle;
    const subtitle = (_g = (_f = (_e = options.detailProps) === null || _e === void 0 ? void 0 : _e.toolbarProps) === null || _f === void 0 ? void 0 : _f.subtitle) !== null && _g !== void 0 ? _g : dictionary_utils_1.dictionarySubtitle;
    const defaultValidationSchema = dictionary_schema_1.useValidationSchema();
    const defaultSorts = react_1.useMemo(() => { var _a, _b; return (_b = (_a = options.tableProps) === null || _a === void 0 ? void 0 : _a.defaultSorts) !== null && _b !== void 0 ? _b : [
        { field: 'order', datakey: 'order', order: 'ASC', type: 'FIELD' },
        { field: 'name', datakey: 'name', order: 'ASC', type: 'FIELD' },
    ]; }, [(_h = options.tableProps) === null || _h === void 0 ? void 0 : _h.defaultSorts]);
    const GeneralFieldsComponent = (_k = (_j = options.detailProps) === null || _j === void 0 ? void 0 : _j.GeneralFieldsComponent) !== null && _k !== void 0 ? _k : dictionary_fields_1.DictionaryFields;
    const toolbarProps = react_1.useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        return ({
            after: react_1.default.createElement(dictionary_toolbar_1.DictionaryToolbar, null),
            ActionBar: dictionary_utils_1.dictionaryActionbarFactory({
                showBtn: (_b = (_a = options.detailProps) === null || _a === void 0 ? void 0 : _a.toolbarProps) === null || _b === void 0 ? void 0 : _b.showBtn,
                After: (_d = (_c = options.detailProps) === null || _c === void 0 ? void 0 : _c.toolbarProps) === null || _d === void 0 ? void 0 : _d.After,
                Before: (_f = (_e = options.detailProps) === null || _e === void 0 ? void 0 : _e.toolbarProps) === null || _f === void 0 ? void 0 : _f.Before,
            }),
            subtitle,
            ...(_g = options.detailProps) === null || _g === void 0 ? void 0 : _g.toolbarProps,
        });
    }, [(_l = options.detailProps) === null || _l === void 0 ? void 0 : _l.toolbarProps]);
    const initNewItem = event_callback_hook_1.useEventCallback(() => {
        var _a, _b;
        const obj = {
            id: uuid_1.v4(),
            active: true,
        };
        if (((_a = options.detailProps) === null || _a === void 0 ? void 0 : _a.initNewItem) !== undefined) {
            return {
                ...obj,
                ...(_b = options.detailProps) === null || _b === void 0 ? void 0 : _b.initNewItem(),
            };
        }
        else {
            return obj;
        }
    });
    return {
        ...options,
        tableProps: {
            ...options.tableProps,
            columns,
            defaultSorts,
            createRowStyle,
        },
        detailProps: {
            ...options.detailProps,
            initNewItem,
            GeneralFieldsComponent,
            toolbarProps,
            validationSchema: (_o = (_m = options.detailProps) === null || _m === void 0 ? void 0 : _m.validationSchema) !== null && _o !== void 0 ? _o : defaultValidationSchema,
        },
    };
}
exports.useDictionaryEvidence = useDictionaryEvidence;
//# sourceMappingURL=dictionary-evidence.js.map